import { render, staticRenderFns } from "./search-box-qa.vue?vue&type=template&id=679f8280&scoped=true"
import script from "./search-box-qa.vue?vue&type=script&lang=js"
export * from "./search-box-qa.vue?vue&type=script&lang=js"
import style0 from "./search-box-qa.vue?vue&type=style&index=0&id=679f8280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679f8280",
  null
  
)

export default component.exports